<template>
  <div class="page-wrapper">
    <div class="viewpage-caption-container">
      <div class="title">{{title}}
        <slot name="sheet-tags"></slot>
      </div>

      <div>
        <slot name="actions"></slot>
      </div>
    </div>
    <el-card :class="bgcolorClass" class="search-area" :body-style="{padding:'8px'}" v-show="showCard">
      <div>
        <slot name="search"></slot>
      </div>
    </el-card>
    <el-row class="list" :class="bgcolorClass">
      <slot name="results"></slot>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'TplListBasic',
  props: {
    title: {
      type: String,
      required: true
    },
    showCard: {
      type: Boolean,
      default: true
    },
    bgcolorClass: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
    max-width: 1678px;
}
.list {
  padding: 5px;
}
.viewpage-caption-container {
  display: flex;
  justify-content: space-between;
  height: 32px;
  line-height: 32px;
  margin-bottom: 12px;
}
.title {
  display: flex;
  text-align: left;
  font-size: 18px;
  color: #939393;
  text-indent: 8px;
  font-weight: bold;
}
.search-area {
  margin-bottom: 8px;
}
.creditBgColor {
  background-color: #f9f5ec;
}
.pOrderBgColor {
  background-color: #ebf3ebda;
}

.bgColor {
  background-color: #fff;
}
</style>
